"use strict";

exports.__esModule = true;
exports.ITEM_COMPONENT_POST = exports.ITEM_COMPONENT_MOBILE_TOI = exports.ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE = exports.ITEM_COMPONENT_LIST_ITEM = exports.LIST_COMPONENT_MOBILE = exports.LIST_COMPONENT_SIMPLE = exports.LIST_COMPONENT_MASONRY = void 0;
var LIST_COMPONENT_MASONRY = 'PostListMasonry';
exports.LIST_COMPONENT_MASONRY = LIST_COMPONENT_MASONRY;
var LIST_COMPONENT_SIMPLE = 'PostListSimple';
exports.LIST_COMPONENT_SIMPLE = LIST_COMPONENT_SIMPLE;
var LIST_COMPONENT_MOBILE = 'PostListMobile';
exports.LIST_COMPONENT_MOBILE = LIST_COMPONENT_MOBILE;
var ITEM_COMPONENT_LIST_ITEM = 'PostListItem';
exports.ITEM_COMPONENT_LIST_ITEM = ITEM_COMPONENT_LIST_ITEM;
var ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE = 'SideBySideMobile';
exports.ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE = ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE;
var ITEM_COMPONENT_MOBILE_TOI = 'TextOnImageMobile';
exports.ITEM_COMPONENT_MOBILE_TOI = ITEM_COMPONENT_MOBILE_TOI;
var ITEM_COMPONENT_POST = 'Post';
exports.ITEM_COMPONENT_POST = ITEM_COMPONENT_POST;